import React from "react";
import { MyPageDrawer } from "../../components/mypage";

const QuestionList = () => {
  return (
    <section>
      <MyPageDrawer />
      <div className="mypage-container">
        <h2>質問一覧</h2>
      </div>
    </section>
  );
};

export default QuestionList;
